// extracted by mini-css-extract-plugin
export default {"peg":"Peg_peg__9Qalq","small":"Peg_small__Gxdf4"};